'use client';
var classes = {"root":"m_e615b15f","section":"m_599a2148"};

export { classes as default };
//# sourceMappingURL=Card.module.css.mjs.map
